import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { BalanceOperation, BalanceOperationResponse } from './types'
import { $params } from '../../../../features/router'

export const operationsMounted = createEvent()

export const getBalanceOperations = fx<void, BalanceOperationResponse>({
  method: 'GET',
  url: '/money_history',
})

export const $operations = restore<BalanceOperation[]>(
  getBalanceOperations.doneData.map((doneData) => doneData.body.items),
  [],
)

sample({
  clock: [operationsMounted],
  source: $params,
  fn: (params) => {
    let clientID, accountID
    if (params) {
      accountID = params.accountID
      clientID = params.clientID
    }
    return {
      url: `/money_history?where={"sourceId":"${accountID}", "clientId":"${clientID}"}`,
    }
  },
  target: [getBalanceOperations],
})
